module.exports = __webpack_public_path__ + "static/johndigweed_1-465dfd39b159f6f4eb2372e784fa9e01.jpg";